<template>
  <div class="mobile-top-up">
    <div>
      <div class="phone-number-form">
        <svg-icon name="ais_icon" class="ais_icon" />
        <md-input-item
          ref="name"
          v-model="phone"
          preview-type="text"
          :title="$t('mobileNumber')"
          :placeholder="$t('mobileNumber')"
          maxlength="10"
          is-title-latent
          is-virtual-keyboard
          clearable
          size="large"
        />
      </div>

      <md-radio-group v-model="amount" class="radio-list">
        <md-radio-box
          v-for="item in options"
          :key="item"
          class="radio-item"
          :name="item"
        >
          <div>Rp{{ item }}</div>
          <div class="pay-amount">Pay Rp{{ item + '.00' }}</div>
        </md-radio-box>
      </md-radio-group>
    </div>

    <div class="submit-button">
      <md-button :type="phone.length < 10 || !amount ? 'disabled' : 'primary'" @click="handlePay">{{ $t('payNow') }}</md-button>
    </div>
  </div>
</template>

<script>
import { InputItem, Field, RadioGroup, RadioBox, Button, Toast } from 'mand-mobile'
import { phoneRechargePage } from '@/api/mobile-top-up'
import { fenToYanAndFormat } from '@/utils/format-amount'
// 手机充值
export default {
  name: 'MobileTopUp',

  components: {
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [RadioBox.name]: RadioBox,
    [Button.name]: Button,
    [InputItem.name]: InputItem
  },

  filters: {
    fenToYanAndFormat
  },

  data () {
    return {
      phone: '',
      amount: '',
      options: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 150, 200]
    }
  },

  async created () {
    const result = await phoneRechargePage()
    this.phone = result.phone
  },

  methods: {
    async handlePay () {
      if (this.phone === '') {
        return Toast.failed(this.$t('phoneNotEmpty')) // 手机号不能为空
      }

      if (`${this.phone}`.length < 10) {
        return Toast.failed(this.$t('checkPhoneNum')) // 请检查手机号码是否正确
      }
      this.$router.push({ name: 'MobileTopUpPay', query: { phone: this.phone, amount: this.amount } })
    }
  }
}
</script>

<style scoped lang="scss">
.mobile-top-up {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 100px;
  min-height: 100%;
}

.phone-number-form {
  padding: 68px 64px 100px;
  background: #fff;
  border-radius: 0 0 72px 72px;
  box-shadow: 0 8px 32px 0 rgba(138, 149, 158, 0.2);

  .ais_icon {
    width: 92px;
    height: 64px;
    margin-bottom: 40px;
  }

  ::v-deep {
    .md-field-item-title {
      color: #7f7f7f;
      font-size: 28px;
    }

    .md-field-item-content {
      height: 230px;

      &::before {
        border-color: #f0f0f0;
      }
    }
  }
}

.radio-list {
  display: flex;
  justify-content: space-between;
  flex-flow: wrap;
  margin-top: 92px;
  padding: 0 50px;

  .radio-item {
    margin-bottom: 36px;
    padding: 24px 0 24px 0;
    width: 180px;
    font-size: 36px;
    color: #777;
    font-weight: 500;

    .pay-amount {
      font-size: 24px;
      color: #b2b2b2;
    }
  }
}

.submit-button {
  padding: 0 40px;
}
</style>
